import { Add, ArrowDropDown, ArrowDropUp, Remove } from "@mui/icons-material";
import { IconButton, Stack, TextField, Tooltip } from "@mui/material";
import { Editor } from "@tiptap/react";
import { useState } from "react";

interface NoteFontSizeProps {
    editor: Editor;
    mode: number;
}

export default function NoteFontSize({ editor, mode }: NoteFontSizeProps) {
    const [noteFontSize, setNoteFontSize] = useState(12);
    const [fontSizeInput, setFontSizeInput] = useState("12");


    const applyFontSizeToEditor = (size: number) => {
        const { from, to, empty } = editor.state.selection;

        setNoteFontSize(size);

        if (!empty) {
            editor.chain().focus().setFontSize(`${size}`).run();
        } else {
            editor.chain().focus().setFontSize(`${size}`).run();
        }
    };


    const handleFontSizeInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFontSizeInput(e.target.value);
    };

    const handleFontSizeKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            const parsed = Number(fontSizeInput);
            if (!isNaN(parsed) && parsed > 0) {
                applyFontSizeToEditor(parsed);
                if (editor.state.selection.empty) {
                    editor.commands.focus();
                }
                (e.target as HTMLInputElement).blur();
            }
        }
    };
    

    const increaseFontSize = () => {
        const newSize = noteFontSize + 1;
        setFontSizeInput(String(newSize));
        applyFontSizeToEditor(newSize);
    };

    const decreaseFontSize = () => {
        const newSize = noteFontSize - 1;
        setFontSizeInput(String(newSize));
        applyFontSizeToEditor(newSize);
    };

    return (
        <Stack direction="row" flexShrink={1} sx={{ display: "flex", alignItems: 'center' }}>
            <Tooltip title="Decrease Font Size">
                <IconButton size="small" onClick={decreaseFontSize}
                    sx={{
                        color: mode === 1 ? 'inherit' : 'white'
                    }}
                >
                    <Remove fontSize="small" />
                </IconButton>
            </Tooltip>

            <TextField
                type="number"
                value={fontSizeInput}
                onChange={handleFontSizeInputChange}
                onKeyDown={handleFontSizeKeyDown}
                onBlur={() => {
                    const parsed = Number(fontSizeInput);
                    if (!isNaN(parsed) && parsed > 0) {
                        applyFontSizeToEditor(parsed);
                    }
                }}
                sx={{
                    minWidth: 50,
                    maxWidth: 50,
                    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                        WebkitAppearance: 'none',
                        margin: 0,
                    },
                    '& input[type=number]': {
                        MozAppearance: 'textfield',
                    },
                    '& .MuiOutlinedInput-input': {
                        textAlign: 'center',
                        fontSize: '12px',
                        padding: '4px 8px',
                        color: mode === 1 ? 'inherit' : 'white',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderColor: mode === 1 ? 'inherit' : 'white',
                    },
                }}
                inputProps={{ min: 1 }}
            />

            <Tooltip title="Increase Font Size">
                <IconButton size="small" onClick={increaseFontSize}
                    sx={{
                        color: mode === 1 ? 'inherit' : 'white'
                    }}
                >
                    <Add fontSize="small" />
                </IconButton>
            </Tooltip>
        </Stack>
    );
}
